import { useEffect, useRef } from 'react';
import { AnnotationLayer } from 'pdfjs-dist';
import { EventBus, LinkTarget, PDFLinkService } from 'pdfjs-dist/legacy/web/pdf_viewer.mjs';
import { Container } from './styled';
const linkService = new PDFLinkService({
    eventBus: new EventBus(),
    externalLinkTarget: LinkTarget.BLANK,
    externalLinkRel: 'noreferrer noopener',
});
export function LinkLayer(props) {
    const { page, scale } = props;
    const containerRef = useRef(null);
    useEffect(() => {
        const div = containerRef.current;
        if (!div) {
            return;
        }
        const viewport = page.getViewport({ scale });
        div.style.setProperty('--total-scale-factor', String(scale));
        // eslint-disable-next-line pocketlaw/no-px-units
        div.style.setProperty('--scale-round-x', '1px');
        // eslint-disable-next-line pocketlaw/no-px-units
        div.style.setProperty('--scale-round-y', '1px');
        div.replaceChildren();
        page.getAnnotations({ intent: 'display' }).then((annotations) => {
            const layer = new AnnotationLayer({
                div,
                page,
                viewport,
                linkService,
                structTreeLayer: null,
                accessibilityManager: null,
                annotationCanvasMap: null,
                annotationEditorUIManager: null,
                annotationStorage: null,
                commentManager: null,
            });
            layer.render({
                div,
                page,
                viewport,
                linkService,
                annotations,
                renderForms: false,
            });
        });
    }, [page, scale]);
    return <Container ref={containerRef} className="annotationLayer"/>;
}
